import { Box, createStyles, withStyles } from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { TabDatePicker } from "./TabDatePicker";
import { TabAddOn } from "./TabAddOn";
import { TabPayDeposit } from "./TabPayDeposit";
import { CheckoutStepType } from "../checkoutPage.constants";
import { RootState } from "../../../app/rootReducer";
import { updateTabSelected } from "../../../store/checkoutPage.slide";

const Accordion = withStyles({
  root: {
    "border": "solid 1px #e5e5e5",
    "marginBottom": "20px !important",
    "borderRadius": "4px",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto",
      boxShadow: "0 5px 15px 0 rgba(0, 0, 0, 0.07) !important"
    }
  },
  expanded: {
    marginBottom: "20px !important"
  }
})(MuiAccordion);

const AccordionSummary = withStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      boxShadow: "none",
      borderRadius: "4px",
      padding: "21px 24px",
      margin: "0 !important",
      borderBottom: "solid 1px #e5e5e5",
      [theme.breakpoints.up("sm")]: {
        padding: "30px 35px"
      }
    },
    content: {
      "margin": "0 !important",
      "fontSize": "16px",
      "color": "#4b5462",
      "fontWeight": "normal",
      "fontFamily": "Axiforma, serif, sans-serf !important",
      "letterSpacing": "0.36px",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "&$expanded": {
        fontWeight: "500"
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: "20px"
      }
    },
    expanded: {
      "borderBottom": 0,
      "&.firstAccordion": {
        borderBottom: "solid 1px #e5e5e5"
      }
    }
  })
)(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    "padding": theme.spacing(2),
    "&.pay-deposit": {
      padding: 0
    }
  }
}))(MuiAccordionDetails);

const TabItem = ({
  id,
  quoteId,
  checkoutSteps
}: {
  id: string;
  quoteId: string;
  checkoutSteps: CheckoutStepType[];
}) => {
  if (id === "installation-date")
    return <TabDatePicker quoteId={quoteId} hasAddOn={checkoutSteps.some((i) => i.id === "add-ons")} />;
  if (id === "add-ons") return <TabAddOn quoteId={quoteId} />;
  return <TabPayDeposit quoteId={quoteId} />;
};

export const CheckoutTabs = ({ checkoutSteps, quoteId }: { checkoutSteps: CheckoutStepType[]; quoteId: string }) => {
  const { tabSelected, timer } = useSelector((state: RootState) => state.checkout);
  const dispatch = useDispatch();

  return (
    <Box>
      {checkoutSteps.map((item, idx) => (
        <Accordion square expanded={item.id === tabSelected} key={idx}>
          <AccordionSummary
            aria-controls="panel1d-content"
            onClick={() => dispatch(updateTabSelected(item.id))}
            className={item.id === "installation-date" ? "firstAccordion" : ""}
            id={item.id}
          >
            <span style={item.id === tabSelected ? { color: "#1e073f" } : {}}>
              {idx + 1}. {item.label}
            </span>
            {((item.id === "installation-date" && !!timer) ||
              (item.id === "add-ons" && tabSelected === "pay-deposit")) && <CheckCircleIcon htmlColor="#4c9735" />}
          </AccordionSummary>
          <AccordionDetails className={item.id === "pay-deposit" ? "pay-deposit" : ""}>
            <TabItem id={item.id} quoteId={quoteId} checkoutSteps={checkoutSteps} />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
